export const MetroInterestCard = {
  name: 'MetroInterestCard',
  props: {
    keyword: {
      type: String,
      default: 'pressure washing'
    },
    geo: {
      type: String,
      default: 'US-FL'
    },
    title: {
      type: String,
      default: 'Trending areas'
    },
    height: {
      type: String,
      default: 'h-100'
    }
  },
  data() {
    return {
      metroData: {
        loading: false,
        error: null,
        lastUpdated: null,
        selectedPeriod: '30d',
        metros: [],
        hasData: false,
        totalMetros: 0,
        currentPage: 1,
        itemsPerPage: 5
      }
    };
  },
  computed: {
    cardId() {
      return `metro-card-${this._uid}`;
    },
    paginatedMetros() {
      const start = (this.metroData.currentPage - 1) * this.metroData.itemsPerPage;
      const end = start + this.metroData.itemsPerPage;
      return this.metroData.metros.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.metroData.metros.length / this.metroData.itemsPerPage);
    },
    showingRange() {
      const start = (this.metroData.currentPage - 1) * this.metroData.itemsPerPage + 1;
      const end = Math.min(start + this.metroData.itemsPerPage - 1, this.metroData.metros.length);
      return `${start}-${end} of ${this.metroData.metros.length}`;
    }
  },
  methods: {
    async fetchMetroData() {
      this.metroData.loading = true;
      this.metroData.error = null;
      
      try {
        // Dummy response to save API calls
        const dummyResponse = {
          data: {
            contents: JSON.stringify({
              "search_metadata": {
                "id": "68ccd7c3fd81c89c753ee485",
                "status": "Success",
                "json_endpoint": "https://serpapi.com/searches/785dd533f443c54b/68ccd7c3fd81c89c753ee485.json",
                "created_at": "2025-09-19 04:10:43 UTC",
                "processed_at": "2025-09-19 04:10:43 UTC",
                "google_trends_url": "https://trends.google.com/trends/embed/explore/RELATED_QUERIES?hl=en&tz=420&req=%7B%22comparisonItem%22%3A%5B%7B%22keyword%22%3A%22pressure+washing%22%2C%22geo%22%3A%22US-FL%22%2C%22time%22%3A%22today+1-m%22%7D%5D%2C%22category%22%3A0%2C%22property%22%3A%22%22%7D",
                "raw_html_file": "https://serpapi.com/searches/785dd533f443c54b/68ccd7c3fd81c89c753ee485.html",
                "prettify_html_file": "https://serpapi.com/searches/785dd533f443c54b/68ccd7c3fd81c89c753ee485.prettify",
                "total_time_taken": 2.49
              },
              "search_parameters": {
                "engine": "google_trends",
                "q": "pressure washing",
                "hl": "en",
                "geo": "US-FL",
                "date": "today 1-m",
                "tz": "420",
                "data_type": "RELATED_QUERIES"
              },
              "related_queries": {
                "rising": [
                  {
                    "query": "texas pressure washing store",
                    "value": "Breakout",
                    "extracted_value": 70600,
                    "link": "https://trends.google.com/trends/explore?q=texas+pressure+washing+store&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=texas+pressure+washing+store&tz=420"
                  },
                  {
                    "query": "pressure washing company near me",
                    "value": "Breakout",
                    "extracted_value": 59600,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+company+near+me&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+company+near+me&tz=420"
                  },
                  {
                    "query": "pressure washing jobs near me",
                    "value": "Breakout",
                    "extracted_value": 55250,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+jobs+near+me&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+jobs+near+me&tz=420"
                  },
                  {
                    "query": "pressure washing store near me",
                    "value": "Breakout",
                    "extracted_value": 48250,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+store+near+me&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+store+near+me&tz=420"
                  },
                  {
                    "query": "roof pressure washing near me",
                    "value": "Breakout",
                    "extracted_value": 42650,
                    "link": "https://trends.google.com/trends/explore?q=roof+pressure+washing+near+me&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=roof+pressure+washing+near+me&tz=420"
                  },
                  {
                    "query": "sodium hypochlorite",
                    "value": "Breakout",
                    "extracted_value": 38550,
                    "link": "https://trends.google.com/trends/explore?q=sodium+hypochlorite&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=sodium+hypochlorite&tz=420"
                  },
                  {
                    "query": "commercial pressure washing companies near me",
                    "value": "Breakout",
                    "extracted_value": 36550,
                    "link": "https://trends.google.com/trends/explore?q=commercial+pressure+washing+companies+near+me&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=commercial+pressure+washing+companies+near+me&tz=420"
                  },
                  {
                    "query": "pressure washing logos",
                    "value": "Breakout",
                    "extracted_value": 36500,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+logos&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+logos&tz=420"
                  },
                  {
                    "query": "pressure washing pricing guide",
                    "value": "Breakout",
                    "extracted_value": 34850,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+pricing+guide&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+pricing+guide&tz=420"
                  },
                  {
                    "query": "pressure washing companies florida",
                    "value": "+100%",
                    "extracted_value": 100,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+companies+florida&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+companies+florida&tz=420"
                  },
                  {
                    "query": "pressure washing orlando",
                    "value": "+80%",
                    "extracted_value": 80,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+orlando&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+orlando&tz=420"
                  },
                  {
                    "query": "pressure washing sarasota",
                    "value": "+70%",
                    "extracted_value": 70,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+sarasota&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+sarasota&tz=420"
                  },
                  {
                    "query": "fence pressure washing",
                    "value": "+70%",
                    "extracted_value": 70,
                    "link": "https://trends.google.com/trends/explore?q=fence+pressure+washing&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=fence+pressure+washing&tz=420"
                  },
                  {
                    "query": "roof pressure washing",
                    "value": "+60%",
                    "extracted_value": 60,
                    "link": "https://trends.google.com/trends/explore?q=roof+pressure+washing&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=roof+pressure+washing&tz=420"
                  },
                  {
                    "query": "commercial pressure washing services",
                    "value": "+50%",
                    "extracted_value": 50,
                    "link": "https://trends.google.com/trends/explore?q=commercial+pressure+washing+services&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=commercial+pressure+washing+services&tz=420"
                  }
                ],
                "top": [
                  {
                    "query": "pressure washing near me",
                    "value": "100",
                    "extracted_value": 100,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+near+me&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+near+me&tz=420"
                  },
                  {
                    "query": "pressure washing services",
                    "value": "83",
                    "extracted_value": 83,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+services&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+services&tz=420"
                  },
                  {
                    "query": "pressure washing service",
                    "value": "52",
                    "extracted_value": 52,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+service&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+service&tz=420"
                  },
                  {
                    "query": "pressure washer",
                    "value": "46",
                    "extracted_value": 46,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washer&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washer&tz=420"
                  },
                  {
                    "query": "commercial pressure washing",
                    "value": "45",
                    "extracted_value": 45,
                    "link": "https://trends.google.com/trends/explore?q=commercial+pressure+washing&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=commercial+pressure+washing&tz=420"
                  },
                  {
                    "query": "pressure washing business",
                    "value": "45",
                    "extracted_value": 45,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+business&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+business&tz=420"
                  },
                  {
                    "query": "pressure washing jacksonville",
                    "value": "44",
                    "extracted_value": 44,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+jacksonville&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+jacksonville&tz=420"
                  },
                  {
                    "query": "pressure washing companies",
                    "value": "36",
                    "extracted_value": 36,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+companies&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+companies&tz=420"
                  },
                  {
                    "query": "pressure washing driveway",
                    "value": "35",
                    "extracted_value": 35,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+driveway&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+driveway&tz=420"
                  },
                  {
                    "query": "pressure washing company",
                    "value": "34",
                    "extracted_value": 34,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+company&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+company&tz=420"
                  },
                  {
                    "query": "pressure washing orlando",
                    "value": "34",
                    "extracted_value": 34,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+orlando&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+orlando&tz=420"
                  },
                  {
                    "query": "roof pressure washing",
                    "value": "33",
                    "extracted_value": 33,
                    "link": "https://trends.google.com/trends/explore?q=roof+pressure+washing&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=roof+pressure+washing&tz=420"
                  },
                  {
                    "query": "house pressure washing",
                    "value": "33",
                    "extracted_value": 33,
                    "link": "https://trends.google.com/trends/explore?q=house+pressure+washing&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=house+pressure+washing&tz=420"
                  },
                  {
                    "query": "pressure washing house",
                    "value": "31",
                    "extracted_value": 31,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+house&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+house&tz=420"
                  },
                  {
                    "query": "pressure washing tampa",
                    "value": "27",
                    "extracted_value": 27,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+tampa&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+tampa&tz=420"
                  },
                  {
                    "query": "pressure washing miami",
                    "value": "24",
                    "extracted_value": 24,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+miami&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+miami&tz=420"
                  },
                  {
                    "query": "pressure washing equipment",
                    "value": "18",
                    "extracted_value": 18,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+equipment&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+equipment&tz=420"
                  },
                  {
                    "query": "pressure washing jacksonville fl",
                    "value": "18",
                    "extracted_value": 18,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+jacksonville+fl&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+jacksonville+fl&tz=420"
                  },
                  {
                    "query": "residential pressure washing",
                    "value": "16",
                    "extracted_value": 16,
                    "link": "https://trends.google.com/trends/explore?q=residential+pressure+washing&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=residential+pressure+washing&tz=420"
                  },
                  {
                    "query": "fence pressure washing",
                    "value": "16",
                    "extracted_value": 16,
                    "link": "https://trends.google.com/trends/explore?q=fence+pressure+washing&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=fence+pressure+washing&tz=420"
                  },
                  {
                    "query": "pressure washing sarasota",
                    "value": "14",
                    "extracted_value": 14,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+sarasota&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+sarasota&tz=420"
                  },
                  {
                    "query": "pressure washing pensacola",
                    "value": "13",
                    "extracted_value": 13,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+pensacola&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+pensacola&tz=420"
                  },
                  {
                    "query": "pressure washing companies florida",
                    "value": "12",
                    "extracted_value": 12,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+companies+florida&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+companies+florida&tz=420"
                  },
                  {
                    "query": "pressure washing service near me",
                    "value": "12",
                    "extracted_value": 12,
                    "link": "https://trends.google.com/trends/explore?q=pressure+washing+service+near+me&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=pressure+washing+service+near+me&tz=420"
                  },
                  {
                    "query": "deck pressure washing",
                    "value": "11",
                    "extracted_value": 11,
                    "link": "https://trends.google.com/trends/explore?q=deck+pressure+washing&date=today+1-m&geo=US-FL",
                    "serpapi_link": "https://serpapi.com/search.json?data_type=RELATED_QUERIES&date=today+1-m&engine=google_trends&geo=US-FL&hl=en&q=deck+pressure+washing&tz=420"
                  }
                ]
              }
            })
          }
        };

        // Use dummy response instead of API call
        const response = dummyResponse;
        
        // Commented out actual API call to save on limits
        /*
        const serpApiKey = '3bee4b56359f50a8d713a8a2dcd7b6143b7f6cc92c445ed275fc58cb01564f21';
        const proxyUrl = 'https://api.allorigins.win/get?url=';
        const timeframe = this.convertPeriodToTimeframe(this.metroData.selectedPeriod);
        
        const serpApiUrl = 'https://serpapi.com/search.json';
        const params = new URLSearchParams({
          engine: 'google_trends',
          q: this.keyword,
          geo: this.geo,
          date: timeframe,
          data_type: 'RELATED_QUERIES', // Use this instead of GEO_MAP
          api_key: serpApiKey
        });
        
        const fullUrl = `${serpApiUrl}?${params}`;
        const encodedUrl = encodeURIComponent(fullUrl);
        
        const response = await axios.get(`${proxyUrl}${encodedUrl}`);
        */
        
        const data = JSON.parse(response.data.contents);
        
        // Since we can't get real metro data, we'll create a meaningful alternative
        this.processAlternativeMetroData(data);
        this.metroData.lastUpdated = new Date();
        
      } catch (error) {
        console.error('Error fetching metro data:', error);
        this.metroData.error = `Metro data not available through current API limitations`;
        this.showAPILimitation();
      } finally {
        this.metroData.loading = false;
      }
    },

    processAlternativeMetroData(data) {
      // Since SerpApi doesn't support GEO_MAP for single queries,
      // we'll show related location-based queries instead
      const locationQueries = [];
      
      if (data.related_queries) {
        // Extract location-based queries from related queries
        const allQueries = [
          ...(data.related_queries.rising || []),
          ...(data.related_queries.top || [])
        ];
        
        allQueries.forEach(query => {
          // Look for city/metro names in the query
          const cities = ['orlando', 'tampa', 'jacksonville', 'miami', 'fort', 'st petersburg', 'clearwater', 'lakeland', 'kissimmee', 'gainesville', 'sarasota', 'pensacola'];
          const queryLower = query.query.toLowerCase();
          
          cities.forEach(city => {
            if (queryLower.includes(city)) {
              locationQueries.push({
                rank: locationQueries.length + 1,
                name: query.query,
                value: query.extracted_value || Math.floor(Math.random() * 50) + 20,
                displayValue: query.value || (query.extracted_value ? query.extracted_value.toString() : '0'),
                isLocationQuery: true
              });
            }
          });
        });
      }
      
      // If no location queries found, show the limitation
      if (locationQueries.length === 0) {
        this.metroData.metros = [];
        this.metroData.hasData = false;
        this.metroData.apiLimitation = true;
      } else {
        // Sort by value and assign ranks
        locationQueries.sort((a, b) => b.value - a.value);
        locationQueries.forEach((query, index) => {
          query.rank = index + 1;
        });
        
        this.metroData.metros = locationQueries;
        this.metroData.hasData = true;
        this.metroData.apiLimitation = false;
      }
    },

    showAPILimitation() {
      this.metroData.metros = [];
      this.metroData.hasData = false;
      this.metroData.apiLimitation = true;
    },

    processMetroData(data) {
      const metros = [];
      
      if (data.interest_by_region && data.interest_by_region.length > 0) {
        data.interest_by_region.forEach((region, index) => {
          metros.push({
            rank: index + 1,
            name: region.location,
            value: region.extracted_value || 0,
            displayValue: region.value || '0'
          });
        });
        
        // Sort by value descending
        metros.sort((a, b) => b.value - a.value);
        
        // Re-assign ranks after sorting
        metros.forEach((metro, index) => {
          metro.rank = index + 1;
        });
        
        this.metroData.metros = metros;
        this.metroData.hasData = metros.length > 0;
        this.metroData.totalMetros = metros.length;
      } else {
        this.metroData.metros = [];
        this.metroData.hasData = false;
        this.metroData.totalMetros = 0;
      }
      
      this.metroData.currentPage = 1; // Reset to first page
    },

    convertPeriodToTimeframe(period) {
      switch (period) {
        case '7d': return 'now 7-d';
        case '30d': return 'today 1-m';
        case '90d': return 'today 3-m';
        default: return 'today 1-m';
      }
    },

    updateMetroPeriod(period) {
      this.metroData.selectedPeriod = period;
      this.fetchMetroData();
    },

    getBarWidth(value, maxValue) {
      if (maxValue === 0) return 0;
      return Math.max((value / maxValue) * 100, 2); // Minimum 2% width for visibility
    },

    nextPage() {
      if (this.metroData.currentPage < this.totalPages) {
        this.metroData.currentPage++;
      }
    },

    prevPage() {
      if (this.metroData.currentPage > 1) {
        this.metroData.currentPage--;
      }
    },

    formatTime(date) {
      if (!date) return '';
      const dateObj = date instanceof Date ? date : new Date(date);
      if (isNaN(dateObj.getTime())) return 'Invalid date';
      return dateObj.toLocaleTimeString('en-US', { 
        hour: 'numeric', 
        minute: '2-digit',
        hour12: true 
      });
    }
  },
  
  mounted() {
    this.fetchMetroData();
  },
  
  template: '#metro-trends'
};
